import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

const ConfirmDialog = ({
  open,
  onOpenChange,
  title = 'Are you sure?',
  description = 'This action cannot be undone.',
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  onConfirm,
  destructive = true,
  testId = 'confirm-dialog',
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-white" data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl font-bold text-[#020617]">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-[#64748B]">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel className="bg-[#F1F5F9] text-[#020617] hover:bg-[#E2E8F0] border-0" data-testid={`${testId}-cancel`}>
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            className={destructive ? 'bg-[#EF4444] text-white hover:bg-[#DC2626]' : 'bg-[#0052FF] text-white hover:bg-[#003ECC]'}
            onClick={onConfirm}
            data-testid={`${testId}-confirm`}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmDialog;
